import { makeStyles } from "@material-ui/core";

export const useSoilFLOStyles = makeStyles({
  soilFLOField: {
    "& .MuiOutlinedInput-root": {
      backgroundColor: "#fdf6ec",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#f0a842",
    },
    "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "#f0a842",
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#f0a842",
    },
    "& .MuiInputBase-input": {
      color: "#666",
    },
  },
});
